import React from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import styles from './index.module.css'

export default function Home() {
	return (
		<div id='page-container' className={'homeImage'}>
			<Header />
			<div className={styles.container}>
				<div className={styles.heading}>
					<h1>Gemäldeprojekt mit Datenbank, Grainau</h1>

					<label className={styles.oldLabel} htmlFor='arbeitsbezeichnung'>
						Arbeitstitel alt
					</label>
					<h2 id={styles.arbeitsbezeichnung}>
						"Grainauer Maler&nbsp; ~ &nbsp;Grainau-Maler"
					</h2>
					<label className={styles.newLabel} htmlFor='arbeitsbezeichnung'>
						Vorschlag neu
					</label>
					<h2 id={styles.arbeitsbezeichnung}>
						"Rund um das Wettersteingebirge"
					</h2>
				</div>

				<div className={styles['background-information']}>
					<h3>
						Anso Weise (1895 - 1986): "Obergrainau, Pfarrkirche mit Zugspitze"{' '}
					</h3>
				</div>
			</div>
			<Footer />
		</div>
	)
}
